import {
  CoverageNotesPanel,
  RfpCoverageDetailsPanel,
} from "@platform/btx-grid-components";
import { SideBarDef } from "ag-grid-community";

import ReviewPanel from "../components/SideBarPanels/ReviewPanel/ReviewPanel";

export interface DefaultSideBarParams {
  ecoRfpId: string;
  coverageId?: string;
  benefitPlanType?: string;
  enabledBTXReviewPanel?: boolean;
}

export const buildDefaultSideBar = ({
  ecoRfpId,
  coverageId,
  benefitPlanType,
  enabledBTXReviewPanel,
}: DefaultSideBarParams): SideBarDef => ({
  toolPanels: [
    {
      id: "details",
      labelDefault: "Details",
      labelKey: "details",
      iconKey: "menu",
      toolPanel: RfpCoverageDetailsPanel,
    },
    {
      id: "notes",
      labelDefault: "Notes",
      labelKey: "notes",
      iconKey: "notesOutlined",
      toolPanel: CoverageNotesPanel,
      toolPanelParams: {
        ecoRfpId,
        coverageId,
        benefitPlanType,
      },
    },
    ...(enabledBTXReviewPanel
      ? [
          {
            id: "overview",
            labelDefault: "Needs Review",
            labelKey: "overview",
            iconKey: "chart",
            toolPanel: ReviewPanel,
            toolPanelParams: {
              title: "Needs Review",
            },
          },
        ]
      : []),
  ],
});
